import { render, staticRenderFns } from "./CustomerRank.vue?vue&type=template&id=04963725&scoped=true"
import script from "./CustomerRank.vue?vue&type=script&lang=js"
export * from "./CustomerRank.vue?vue&type=script&lang=js"
import style0 from "./CustomerRank.vue?vue&type=style&index=0&id=04963725&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04963725",
  null
  
)

export default component.exports